import { Categories } from 'constants/categories';
import { CATEGORIES } from 'constants/filter';
import { useTranslationsContext } from 'contexts/translationsContext';
import { useIsLessThan } from 'fxs-utils';

import { IconSquareCheckFilled, IconSquareFilled } from '@tabler/icons-react';

import { RowTypes } from './RowType';
import {
	FXSFilterCategoryIcon,
	FXSFilterCategoryLabel,
	FXSFilterCategoryLeft,
	FXSFilterCategoryRow,
	FXSFilterCheckbox,
	FXSFilterModalRow,
	FXSFilterTitle
} from './styles';

const CategoryRow = ({ activeTrades, state, handleClick }: RowTypes) => {
	const isLessThan833 = useIsLessThan(833);
	const { t } = useTranslationsContext();

	return (
		<FXSFilterModalRow activeTrade={activeTrades}>
			<FXSFilterTitle isLessThan833={isLessThan833}>
				{t('categories')}
			</FXSFilterTitle>
			{Categories.map((c) => (
				<FXSFilterCategoryRow
					key={c.id}
					disabled={activeTrades}
					onClick={(e) =>
						handleClick(e, c.value, CATEGORIES, null, false)
					}
				>
					<FXSFilterCategoryLeft>
						<FXSFilterCategoryIcon icon={c.value} />
						<FXSFilterCategoryLabel>
							{t(c.label)}
						</FXSFilterCategoryLabel>
					</FXSFilterCategoryLeft>
					<FXSFilterCheckbox
						as={
							state?.categories?.includes(c.value)
								? IconSquareCheckFilled
								: IconSquareFilled
						}
						checked={state?.categories?.includes(c.value)}
						disabled={activeTrades}
						onClick={(e) =>
							handleClick(e, c.value, CATEGORIES, null, false)
						}
					/>
				</FXSFilterCategoryRow>
			))}
		</FXSFilterModalRow>
	);
};

export default CategoryRow;
